export default __webpack_public_path__ + "static/media/data.b8e41778.svg";